import React from "react";
import PropTypes from "prop-types";
import { Skeleton, Typography } from "@mui/material";
import { FormattedMessage, injectIntl } from "react-intl";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { IsSuperAdmin } from "app/components/Authorization";
import { DivRootStyled, DivRowStyled, SpanSpacerStyled } from "./OwnersToolbar.styles";
import { ActionButton } from "../../../../components";
const OwnersToolbar = (props) => {
  const { className, handleClickAdd, totalCount } = props;
  const isSuperAdmin = IsSuperAdmin();
  return /* @__PURE__ */ React.createElement(DivRootStyled, { className }, /* @__PURE__ */ React.createElement(DivRowStyled, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Typography, { variant: "h5" }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: "menu.owners" })), /* @__PURE__ */ React.createElement(Typography, { variant: "subtitle2", textTransform: "uppercase" }, typeof totalCount !== "undefined" ? /* @__PURE__ */ React.createElement(FormattedMessage, { id: "owners.totalCount", values: { totalCount } }) : /* @__PURE__ */ React.createElement(Skeleton, { width: 200 }))), /* @__PURE__ */ React.createElement(SpanSpacerStyled, null), isSuperAdmin && /* @__PURE__ */ React.createElement(ActionButton, { messageId: "owners.add", onClick: handleClickAdd, icon: faPlus })));
};
OwnersToolbar.propTypes = {
  className: PropTypes.string,
  handleClickAdd: PropTypes.func.isRequired
};
export default injectIntl(OwnersToolbar);
